var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("el-card", { staticClass: "box-card" }, [
        _c("h3", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v("ADMIN PORTAL")
        ]),
        _vm._v(" "),
        _c("form", { attrs: { action: this.link, method: "post" } }, [
          _c(
            "button",
            {
              staticClass: "el-button el-button--primary",
              attrs: {
                type: "submit",
                className: "btn btn-outline-theme col-sm-3"
              }
            },
            [_vm._v("\n        Login\n      ")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", { attrs: { src: require("../assets/logo.png"), alt: "" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 